import React from 'react';
import { Routes, Route } from "react-router-dom";
import LoginLayout from '../Layout/Loginindex';
import Login from '../Components/Login/Login';
import Register from '../Components/Login/Register'; 
import ForgotPassword from '../Components/Login/ForgotPassword';
import ForgotPasswordActivation from '../Components/Login/ForgotPasswordActivation';
import Auth from "../Helper/Auth";
import Home from '../Components/Admin/Home';

export default function LoginRoutes(){
  let auth = Auth();
    return(
        <Routes >
          <Route element={<LoginLayout />}>
            {/*auth ? <Route path="/" element={<Home />} /> :  <Route path="/" element={<Login />} /> */}
            {/* <Route path="/Login" element={<Login />} /> */}
            <Route path="/register" element={<Register />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/forgotpasswordactivation/:id" element={<ForgotPasswordActivation />} />
          </Route>
      </Routes>
    )
}